export default (mapImage) => `
  <strong class="sub-tit">새로운 공간에서, 더 좋은 생각을 시작합니다.</strong>
  <p>안녕하세요. 저희 이모션글로벌은 사업 확장 및 업무 환경 개선을 위해 아래와 같이 사무실을 이전하게 되었음을 안내드립니다.</p>
  <img src="${mapImage}" alt="이모션글로벌 사무실 약도" class="notice-map" />
  <div class="address-info">
    <p>도로명 주소 : (06057) 서울 강남구 언주로 726 두산빌딩 15층</p>
    <p>지번주소: (06057) 서울 강남구 논현동 105-7 15층</p>
  </div>
  <p class="closing">새로운 공간에서 더욱 향상된 서비스와 전문성을 바탕으로 고객 여러분의 기대에 부응할 수 있도록 최선을 다하겠습니다. 변함없는 관심과 성원에 깊이 감사드립니다.</p>
  <div class="sign-off">
    <p class="company"><strong>이모션글로벌 임직원 일동</strong></p>
  </div>
`;
